export const ingredientsData = [
  {
    ingredientsName: "BBQ Sauce",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b909fc4a8bed0ddc2f_635823f4ce49290a631f96f8_production-image-9452af5a-8d06-469e-8291-dfc87776d46f.jpeg",
  },
  {
    ingredientsName: "Bison Burger",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66bb765dff1ae5c2e1f9_635823f4ce492905881f96fa_production-image-902d6881-5712-4622-bd94-0d369e34618b.jpeg",
  },
  {
    ingredientsName: "Carrots",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b82304e14e339e2b3f_635823f4ce4929516b1f96fb_production-image-11b08e84-b9f0-4a04-846c-4ac08fe0311b.jpeg",
  },
  {
    ingredientsName: "Cheddar Cheese",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b8a698038bf90578a1_635823f4ce49298ef21f96fc_production-image-6bb6807f-0c37-4e99-a904-16e34fc93a51.jpeg",
  },
  {
    ingredientsName: "Turkey Bacon",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b90238eb55cc9aab12_635823f4ce492914271f96fd_production-image-0a80f031-85b2-4860-ab17-13f82a5d383c.jpeg",
  },
  {
    ingredientsName: "Italian Sausage",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b709fc4af1fb0ddc07_635823f4ce492949fc1f9747_production-image-0f0243e2-ad12-4415-8831-49673c85c2b2.jpeg",
  },
  {
    ingredientsName: "Spinach",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b7dae2e9148e964f7f_635823f4ce4929db4e1f9748_production-image-9c847c8e-7fc6-4d45-94e4-d9e8158cb11e.jpeg",
  },
  {
    ingredientsName: "Zucchini",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba2304e135b89e2b4c_635823f4ce4929cc9f1f971b_production-image-52178431-8646-4502-9758-c29fec0a09ae.jpeg",
  },
  {
    ingredientsName: "Penne",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66bb8cd4f90bb6a86917_635823f4ce4929b4e01f9749_production-image-bb9fc3be-f400-4f25-9415-fbdeb127064c.jpeg",
  },
  {
    ingredientsName: "Tomatoes",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b8765dff7187c2e1de_635823f4ce4929dea91f971c_production-image-d284663f-b214-4d9f-904b-8189dc81a6d7.jpeg",
  },
  {
    ingredientsName: "Marinara Sauce",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b709fc4a1ac70ddc09_635823f4ce492901101f973c_production-image-b5eeaeaa-981c-4b81-b581-e1f30dabd4d9.jpeg",
  },
  {
    ingredientsName: "Butternut Squash",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b7dae2e904cb964f7e_635823f4ce4929607b1f9735_production-image-0a92c370-3ffb-42d9-a5d5-2b185391d9f9.jpeg",
  },
  {
    ingredientsName: "Elbow Macaroni",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66bb5ae22f5127ff53d6_635823f4ce492979d31f9736_production-image-d1c897c6-8ead-4a2a-ba33-d48adf8457c8.jpeg",
  },
  {
    ingredientsName: "Green Beans",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b80238eb2f9f9aab11_635823f4ce49295ae41f9727_production-image-7c712299-a728-48ad-bf50-3a87133b24b4.jpeg",
  },
  {
    ingredientsName: "Chicken Breast",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b809fc4ae6f40ddc20_635823f4ce49293b211f9714_production-image-d2bc4253-5f44-4f36-b0df-f901164bcccb.jpeg",
  },
  {
    ingredientsName: "Almonds",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b7ba0d10704b59598c_635823f4ce492972141f9734_production-image-18a86dae-fcb9-4e24-8006-44b81e050705.jpeg",
  },
  {
    ingredientsName: "Celery",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66bbb343495b2c4678b7_635823f4ce49294da11f9708_production-image-2fb07e7c-f762-4612-a071-75c225afa81d.jpeg",
  },
  {
    ingredientsName: "Cauliflower",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b89f0dd65c00b6ae50_635823f4ce4929625c1f9725_production-image-c00b3715-3661-4964-a8a1-06f53444a494.jpeg",
  },
  {
    ingredientsName: "Parmesan Cheese",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b87c6e9af95293f451_635823f4ce4929a4281f973b_production-image-231ee45f-9624-4cd4-a02d-228fe4de7b59.jpeg",
  },
  {
    ingredientsName: "Ground Beef",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba243b246bd90f9496_635823f4ce49292df81f973a_production-featured-ingredient-image-7261ac7a-c66b-4740-bd3e-05d1f2b308f9.jpeg",
  },
  {
    ingredientsName: "Spinach",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b7dae2e9148e964f7f_635823f4ce4929db4e1f9748_production-image-9c847c8e-7fc6-4d45-94e4-d9e8158cb11e.jpeg",
  },
  {
    ingredientsName: "Ricotta Cheese",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66bb7be30f0a1f054aa1_635823f4ce492947c41f9754_production-image-34ce63bc-75c9-441c-bb61-d70af1bf94b6.jpeg",
  },
  {
    ingredientsName: "Peas",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b9846bcf3997de22cf_635823f4ce49297ffe1f975c_production-image-02a450e1-69de-4d87-b2c1-f9e0ae0f9bcf.jpeg",
  },
  {
    ingredientsName: "Chicken Breast",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b7ba0d102d94595990_635823f4ce49295d901f972e_production-image-3b1cc8ff-85dd-4dbd-be6d-f06a6e2ce0b3.jpeg",
  },
  {
    ingredientsName: "Fresh Mozzarella",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b9a3da7711870acd0d_635823f4ce4929b5b11f9719_production-image-e44e5579-e8d7-4e36-b0d1-588a51cf9f16.jpeg",
  },
  {
    ingredientsName: "Broccoli",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b9a3da7769e80acd0c_635823f4ce49291b031f9758_production-image-a5c5157d-7f45-4a5e-b6bb-a4f7db0f5147.jpeg",
  },
  {
    ingredientsName: "Teriyaki Sauce",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66bb5ae22f16beff53c3_635823f4ce492942641f974d_production-image-a49a3799-b43e-4d8b-b39b-720a0d1bc808.jpeg",
  },
  {
    ingredientsName: "Coconut Nectar",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66bb5ae22f5236ff53c0_635823f4ce4929134b1f974e_production-image-0b846d2b-6ba9-462b-9275-582052561cf5.jpeg",
  },
  {
    ingredientsName: "Basmati Rice",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b7715eea03834e0c3f_635823f4ce492932821f9750_production-image-d910adc3-1e86-40da-a18e-14410d863355.jpeg",
  },
  {
    ingredientsName: "Chicken Thigh",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66baabcbab2a10f2a67e_635823f4ce49296f031f974f_production-image-6fcb43af-f9cd-4821-99b5-b39f167f721d.jpeg",
  },
  {
    ingredientsName: "Arborio Rice",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b87c6e9a3fec93f450_635823f4ce492972461f971a_production-image-506e9db4-36a4-4b75-8d9f-c85538d56521.jpeg",
  },
  {
    ingredientsName: "Top Blade Steak",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66bb684a2042aa466510_635823f4ce492936be1f9771_production-image-7ac4a650-1f9c-411c-acff-fa11ec417e80.jpeg",
  },
  {
    ingredientsName: "White Navy Beans",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66bbb34349e3844678b5_635823f4ce492925111f970c_production-image-45a5ee6a-4c57-4900-9b51-e4147966db1f.jpeg",
  },
  {
    ingredientsName: "Coriander",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b826aa842c9eb59c23_635823f4ce4929a5c61f970a_production-image-0d952097-77c0-4636-9199-01d33d41434d.jpeg",
  },
  {
    ingredientsName: "Onion",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b98b1f5a1cc739be48_635823f4ce4929f4861f9705_production-image-a145796c-067d-4f61-ac03-e7a8db440222.jpeg",
  },
  {
    ingredientsName: "Low-Fat Yogurt",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba0238eb0ba49aab2d_635823f4ce4929a1c61f970b_production-image-8c69aef5-1989-4986-8f32-f51d0723098e.jpeg",
  },
  {
    ingredientsName: "Ground Turkey",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b840d40d253b83f383_635823f4ce492990501f9709_production-image-1ed5cd36-36c2-44a5-9607-f6ffb83c9d64.jpeg",
  },
  {
    ingredientsName: "Greek Yogurt",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba243b24295e0f9497_635823f4ce492986401f9730_production-image-a77fd207-06a3-4192-bce1-ba20e13f7abb.jpeg",
  },
  {
    ingredientsName: "Corn",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b7ba0d10164159598d_635823f4ce4929fae51f972d_production-image-7a8d7874-adcb-4131-b77c-69fad4cbf38f.jpeg",
  },
  {
    ingredientsName: "Sweet Potato",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b7715eea76e84e0c40_635823f4ce49290a4c1f972f_production-image-3a626def-a495-463f-a339-d1e516c6b1c1.jpeg",
  },
  {
    ingredientsName: "Cassava Flour",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba0238eb0c6d9aab2c_635823f4ce49297d8a1f9728_production-image-b4367863-3601-4731-9ea4-29e7e7c60ae5.jpeg",
  },
  {
    ingredientsName: "Cayenne Pepper",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba1b19b206b55b96fe_635823f4ce492982691f9743_production-image-96b6267d-674e-4cb3-ad02-fbfce4837138.jpeg",
  },
  {
    ingredientsName: "Pepper Jack Cheese",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b90238eb61ac9aab1a_635823f4ce492928f31f9721_production-image-55cb6cd2-631d-42bf-92ea-400e14363bbc.jpeg",
  },
  {
    ingredientsName: "Red Bell Pepper",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b709fc4a669c0ddc03_635823f4ce492911c01f9700_production-image-6ade69b4-4668-464d-ad4d-86091006df0e.jpeg",
  },
  {
    ingredientsName: "Sliced Steak",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b8aa89f60ed53c6766_635823f4ce492961001f9724_production-image-95f66445-46db-4d0c-945f-37572e9a34a0.jpeg",
  },
  {
    ingredientsName: "Plain Yogurt",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba0238eb0ba49aab2d_635823f4ce4929a1c61f970b_production-image-8c69aef5-1989-4986-8f32-f51d0723098e.jpeg",
  },
  {
    ingredientsName: "Flame-Seared Steak",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba0238eb386e9aab2b_635823f4ce49290a7a1f972a_production-image-7a84ed92-9002-4df4-8721-99512cd8252c.jpeg",
  },
  {
    ingredientsName: "Russet Potato",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66b7dae2e9938b964f80_635823f4ce492964061f9715_production-image-3a07cee6-bee9-457a-94c6-fa551a76b4a8.jpeg",
  },
  {
    ingredientsName: "Asiago Cheese",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba503a5b914162890d_635823f4ce4929b2191f97ac_production-image-acdd9c8d-ebb3-4068-af66-74795451a8b3.jpeg",
  },
  {
    ingredientsName: "Beef Meatballs",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba503a5b3dfe62890c_635823f4ce4929425e1f97ad_no_meal_placeholder_hcgzhk.png",
  },
  {
    ingredientsName: "Linguine",
    ingredientsImage:
      "https://assets-global.website-files.com/5d03b4e13011831ae4624b37/636a66ba503a5b4bc662890b_635823f4ce492957ad1f97ae_production-image-c0e2cc65-fa0b-4308-a191-f580b004603a.jpeg",
  },
];
